export default "__VITE_ASSET__BCuwFaow__"